import React from 'react';

export default function FiltersContainer({ children, className }) {
  return <div className={`d-flex flex-row flex-wrap align-items-center ${className}`}>{children}</div>;
}
